import config from '../constants/config';
import { DataGetApi } from '../helpers/PostDataApi';
import moment from 'moment';
import getTsepDeviceIdsAndUrls from '../constants/keys';
import payLinkService from '../services/payLinkService';
import { v4 as uuid } from 'uuid';

const getTsepManifestToken = async (location, route) => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user ? user.token : null;
    const apiUrl = route === 'paylink' ? 'getTsepManifestTokenOneTime' : 'getTsepManifestToken';
    const headers = {
      'X-Client-Url': window.location.href,
      'X-Correlation-ID': uuid(),
      ...location?.multipassCredentials,
    };
    const response = await DataGetApi(`${config.BASEURL}${apiUrl}/${location._id}`, location, token, headers);
    return response;
  } catch (err) {
    console.error(err);
    return err;
  }
};

const checkTsepTimestamp = (date) => {
  const yourDateTime = moment(date);
  const timeDifference = moment().diff(yourDateTime);
  const isMoreThan24Hours = timeDifference > 24 * 60 * 60 * 1000;
  return isMoreThan24Hours;
};

const injectTsepScriptDOM = (manifestKey, multipassTSEPId) => {
  const script = document.createElement('script');
  script.src = `${config.TSEP_MANIFEST_VALIDATION_URL}${multipassTSEPId}?${manifestKey}`;
  script.async = true;
  script.id = 'manifest-script';
  document.head.appendChild(script);
};

const updateTsepDetailsLocally = (manifestKey, location) => {
  location.multipassCredentials.tsepManifest = manifestKey ?? null;
  location.multipassCredentials.tsepTimestamp = manifestKey ? new Date().toLocaleString() : null;
  localStorage.setItem('locationPaydetails', JSON.stringify(location));
};

function isMatchingDeviceIdAndUrl(deviceId, domainURL, location) {
  const tsepDeviceIds = getTsepDeviceIdsAndUrls(location);
  const mappedDomains = [
    {
      deviceId: tsepDeviceIds.TSEP_DEVICE_ID_LOCAL,
      url: 'localhost',
    },
    {
      deviceId: tsepDeviceIds.TSEP_DEVICE_ID_DEV,
      url: 'dev.myflexstaging.com',
    },
    {
      deviceId: tsepDeviceIds.TSEP_DEVICE_ID_TEST,
      url: 'test.myflexstaging.com',
    },
    {
      deviceId: tsepDeviceIds.TSEP_DEVICE_ID_STAGING,
      url: 'staging.myflexstaging.com',
    },
    {
      deviceId: tsepDeviceIds.TSEP_DEVICE_ID_PROD,
      url: 'new.mytitaniumflex.com',
    },
  ];
  for (const domainMap of mappedDomains) {
    if (domainMap.deviceId === deviceId && domainMap.url === domainURL) {
      return true;
    }
  }
  return false;
}

const loadTsepManifestScript = async (locationDetails = null, route = null) => {
  try {
    const location = locationDetails || JSON.parse(localStorage.getItem('locationPaydetails'));
    const domainURL = window.location.hostname;
    let multipassCredentials = location?.multipassCredentials;

    if (!multipassCredentials) {
      await payLinkService
        .getTsepFormDataByLocationId(location._id)
        .then((response) => {
          multipassCredentials = response.data.tsepFormData;
          location.multipassCredentials = multipassCredentials;
        })
        .catch((error) => {
          console.error('Error fetching TSEP form data:', error);
          return false;
        });
    }

    const { tsepManifestToken, tsepTimestamp, multipassTSEPId, transactionKey } = multipassCredentials;
    // Before proceeding we need to check if valid tsepId is being used as per domain for the location
    const validDomain = isMatchingDeviceIdAndUrl(multipassTSEPId, domainURL, location);
    if (validDomain === false || transactionKey === null) {
      return false;
    }
    if (tsepManifestToken && tsepTimestamp && !checkTsepTimestamp(tsepTimestamp)) {
      injectTsepScriptDOM(tsepManifestToken, multipassTSEPId);
      return true;
    } else {
      const response = await getTsepManifestToken(location, route);
      if (response.data.statusCode === '200' || response.data.statusCode === 200) {
        const manifestKey = response.data.response.tsepManifest;
        const { multipassTSEPId } = multipassCredentials;
        injectTsepScriptDOM(manifestKey, multipassTSEPId);
        updateTsepDetailsLocally(manifestKey, location);
        return true;
      } else {
        updateTsepDetailsLocally(null);
        console.error('Error loading TSEP manifest script:');
        return false;
      }
    }
  } catch (error) {
    console.error('Error loading TSEP manifest script:', error);
    throw error;
  }
};

const setEventListeners = () => {
  document.addEventListener('input', function (event) {
    const saveCustomerButton = document.getElementById('saveCustomer');
    if (event.target && event.target.id === 'tsep-cardNum') {
      setMaxLength();
      setMaxLengthCvv();
      setMaxWidth();
    }

    if (event.target && event.target.id === 'tsep-cardNum' && saveCustomerButton !== null) {
      setCustomerSaveButton();
    }
  });
};

const unsetEventListeners = () => {
  document.removeEventListener('input');
};

const setCustomerSaveButton = () => {
  const inputField = document.getElementById('tsep-cardNum');
  const saveCustomerButton = document.getElementById('saveCustomer');
  console.log(inputField.value, '---input field');
  if (inputField.value !== '' && saveCustomerButton !== null) {
    document.getElementById('saveCustomer').disabled = true;
  } else {
    document.getElementById('saveCustomer').disabled = false;
  }
};

const setMaxWidth = () => {
  const inputField = document.getElementById('tsep-cardNum');
  if (inputField) {
    const classList = inputField.classList;
    inputField.style.maxWidth = '175px';
    const visa = classList.contains('visa');
    const masterCard = classList.contains('mastercard');
    const discover = classList.contains('discover');
    const amex = classList.contains('amex');

    if (visa || discover || masterCard) {
      inputField.style.maxWidth = '164px';
    } else if (amex) {
      inputField.style.maxWidth = '153px';
    } else {
      inputField.style.maxWidth = '175px';
    }
  }
};

const setMaxLength = () => {
  const inputField = document.getElementById('tsep-cardNum');
  if (inputField) {
    let maxLength = 24;
    const classList = inputField.classList;
    const visa = classList.contains('visa');
    const masterCard = classList.contains('mastercard');
    const discover = classList.contains('discover');
    const amex = classList.contains('amex');

    if (visa || masterCard || discover) {
      maxLength = 16 + 3; // 16 maxLength and plus 3 space character
    } else if (amex) {
      maxLength = 15 + 2; // 15 maxLength and plus 2 space character
    }
    inputField.maxLength = maxLength; // Set maxlength property directly
  } else {
    console.log('Input field with ID "tsep-cardNum" not found.');
  }
};

const setMaxLengthCvv = () => {
  const inputField = document.getElementById('tsep-cardNum');
  const cvvField = document.getElementById('tsep-cvv2');
  if (inputField && inputField.value.trim() !== '' && cvvField) {
    let maxLength = 4;
    const classList = inputField.classList;
    const visaCard = classList.contains('visa');
    const masterCard = classList.contains('mastercard');
    const discoverCard = classList.contains('discover');
    if (visaCard || discoverCard || masterCard) {
      maxLength = 3; // 16 maxLength and plus 3 space character
    }
    cvvField.maxLength = maxLength; // Set maxlength property directly
  } else {
    console.log('Input field with ID "tsep-cardNum" not found.');
  }
};

export { loadTsepManifestScript, setEventListeners, unsetEventListeners };
